.coverageDanger {
  color: var(--paletteRed0);
}

.coverageSuccess {
  color: var(--paletteGreen0);
}
